import type { BreadProps } from "./Interfaces";

export const BreadCrumbs = ({ items }: BreadProps) => {
  return (
    <div className="w-full mb-[30px]">
      <ul className="flex ml-[-35px]">
        {items.map((item, index) => (
          <li key={index} className={`mr-[30px]  ${index === 0 ? "list-none" : ""}`}>
            {item}
          </li>
        ))}
      </ul>
    </div>
  );
};
